import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-code-s-slash-line',
    color: 'text-emerald-500',
    bg: 'bg-emerald-50',
    title: 'システムソフトウェア開発',
    desc: '業務効率化システム、Webアプリケーション、データベース構築など、お客様のニーズに合わせたカスタム開発を提供します。',
  },
  {
    icon: 'ri-smartphone-line',
    color: 'text-pink-500',
    bg: 'bg-pink-50',
    title: 'アプリケーション制作',
    desc: 'iOS・Android対応のモバイルアプリ、業務用アプリケーションの企画から開発、配信までワンストップでサポートします。',
  },
  {
    icon: 'ri-megaphone-line',
    color: 'text-emerald-500',
    bg: 'bg-emerald-50',
    title: 'インターネット広告',
    desc: 'Web広告の企画・運用代行、SNSマーケティング、SEO対策など、デジタルマーケティングを総合的に支援します。',
  },
];

export default function ServicesOverview() {
  return (
    <section className="py-24 bg-gradient-to-b from-pink-50/60 to-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-xs font-semibold tracking-widest text-emerald-500 uppercase mb-3">Our Services</p>
          <h2 className="text-3xl md:text-5xl font-black text-gray-800 mb-4" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            私たちができること
          </h2>
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
            ITの力でお客様のビジネスをフレッシュに変革します
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {services.map((s) => (
            <div
              key={s.title}
              className="bg-white/70 backdrop-blur-sm border border-gray-100 rounded-2xl p-8 hover:border-pink-200 transition-all duration-300 group"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${s.bg} mb-5`}>
                <i className={`${s.icon} ${s.color} text-2xl`}></i>
              </div>
              <h3 className="text-gray-800 font-bold text-base mb-3" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                {s.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/services"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 border border-pink-300 text-pink-500 font-semibold px-7 py-3 rounded-full hover:bg-pink-50 transition-colors text-sm"
          >
            サービス詳細を見る
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
